import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { OccupationModel } from "@app/ps/models/occupation.model";
import { AuthService } from "@app/common/services/auth.service";

@Pipe({ name: 'priorityIndexName' })
@Injectable({ providedIn: 'root' })
export class PriorityIndexNamePipe implements PipeTransform {

  constructor(private authService: AuthService) { }

  isOccupationModel(value: OccupationModel | number): value is OccupationModel {
    return typeof value === 'object' && value !== null && 'priorityIndex' in value;
  }

  transform(occupation: OccupationModel | number): string | null {
    if (occupation === undefined || occupation === null ) {
      return null;
    }

    const project = this.authService.getActualProject();
    if (!project || !project.occupationsPriority || !project.occupationsPriority.categories) {
      return null;
    }

    const categories = project.occupationsPriority.categories;

    let index: number;

    if (typeof occupation === 'number') {
      index = occupation;
    } else if (this.isOccupationModel(occupation)) {
      if (occupation.priorityIndex === undefined || occupation.priorityIndex === null) {
        return null;
      }
      index = occupation.priorityIndex;
    }
    else {
      return null;
    }

    if (categories[index] && categories[index].name) {
      return categories[index].name;
    }
    return null;
  }
}
